import React from 'react';
import classNames from 'classnames';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { compose } from 'redux';

import {
  stringInputSpec,
  stringSelectSpec,
  repeatable,
} from '../../lib/editing-configs';
import styles from './filters.module.less';
import { LinkPropTypes } from './components/prop-types';
import { getQueryParams } from '../../lib/query-param-helpers';
import FilterLink from './components/link';

const FiltersLayout = {
  oneLine: 'one-line',
};

const Filters = ({ layout, filters, history }) => {
  const queryParams = getQueryParams(history);

  return (
    <div className={classNames(styles.wrapper, styles[`wrapper__${layout}`])}>
      <div className={classNames(styles.filters, styles[`filters__${layout}`])}>
        {filters
          .map((filter) => {
            switch (filter.type) {
              case 'link':
                return (
                  <FilterLink
                    queryParams={queryParams}
                    filter={filter}
                    key={filter.$unique_key}
                  />
                );
              default:
                return null;
            }
          })
          .filter(Boolean)}
      </div>
    </div>
  );
};

Filters.propTypes = {
  history: PropTypes.object,
  layout: PropTypes.oneOf([FiltersLayout.oneLine]),
  filters: PropTypes.arrayOf(PropTypes.oneOfType([LinkPropTypes])),
};

Filters.defaultProps = {
  filters: [],
  layout: FiltersLayout.oneLine,
};

Filters.getEditingConfig = (componentDocument) => {
  return [
    stringSelectSpec('layout', 'Layout type', [
      { label: 'One line', value: FiltersLayout.oneLine },
    ]),
    repeatable('filters', 'Filters', 'Filter', (index) => {
      const type = _.get(
        componentDocument,
        `props.filters[${index}].type`,
        'button'
      );

      return [
        stringSelectSpec('type', 'Filter type', [
          { label: 'Unselected', value: '' },
          { label: 'Link', value: 'link' },
        ]),
        ...(type === 'link'
          ? [
              stringInputSpec('label', 'Label'),
              stringInputSpec('param', 'Param name', {
                help: 'The way of handling the link. It will create `example.org?{paramName}={paramValue}`',
              }),
              stringInputSpec('paramValue', 'Param value'),
            ]
          : []),
      ].filter(Boolean);
    }),
  ].filter(Boolean);
};

export default compose(withRouter)(Filters);
